const OfficalPage = () => {

  
  const tableData = [
    {
      clientName: "shane",
      cPhone: "9988776655",
      lawyerName: "Jabili",
      lPhone: "1234567890",
      Comments: "hello",
    },
    {
      clientName: "Mike",
      cPhone: "9998776655",
      lawyerName: "Arya",
      lPhone: "6743567890",
      Comments: "hello",
    },
    {
      clientName: "Limen",
      cPhone: "7688776655",
      lawyerName: "Ram",
      lPhone: "8735967890",
      Comments: "hello",
    },
  ];

  return (
    <div style={styles.page}>
      <h3 style={styles.title}>
        Consulted Users Who Clicked Talk, Consulted Again, Hire Lawyer Button
      </h3>

      {/* Table Section */}
      <div style={styles.gridContainer}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.header}>Client Name</th>
                <th style={styles.header}>C Phoneno.</th>
                <th style={styles.header}>Lawyer Name</th>
                <th style={styles.header}>L Phoneno.</th>
                <th style={styles.header}>Comments</th>
                <th style={styles.header}></th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index} style={styles.row}>
                  <td style={styles.cell}>{row.clientName}</td>
                  <td style={styles.cell}>{row.cPhone}</td>
                  <td style={styles.cell}>{row.lawyerName}</td>
                  <td style={styles.cell}>{row.lPhone}</td>
                  <td style={styles.cell}>{row.Comments}</td>
                  <td style={styles.buttonCell}>
                    <button style={styles.addButton}>Declined</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: "grid",
    gap: "20px",
    paddingLeft: "10%",
    height: "50vh",
    backgroundColor: "#f9f9f9",
  },
  title: {
    paddingRight: "20%",
    margin: "10px 10px",
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "center",
  },
  gridContainer: {
    display: "grid",
    gap: "20px",
    overflow: "hidden",
  },
  tableContainer: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "white",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    minWidth: "1200px",
  },
  header: {
    backgroundColor: "#f4f4f4",
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  cell: {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  buttonCell: {
    padding: "5px",
    textAlign: "center",
    border: "1px solid #ddd",
  },
  addButton: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  noUseButton: {
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  row: {
    backgroundColor: "#fff",
  },
};
export default OfficalPage;
